export default "__VITE_ASSET__Dgx5ACsl__"